export const CAMPEON = 'C';
export const CAMPEON_COMPARTIDO = 'M';
export const SUBCAMPEON = 'S';
export const MEDALLA_ORO = 'O';
export const MEDALLA_PLATA = 'P';
export const MEDALLA_BRONCE = 'B';
